module.exports = __webpack_public_path__ + "img/image-6.b45ffdba.jpg";